// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import Header from '../../components/Header';
import Pagination from '../../internal/Pagination';
import Articles from './Internal/Articles';
import FeaturedArticle from './Internal/FeaturedArticle';
import RecommendedArticles from './Internal/RecommendedArticles';
import Search from '../../internal/Search';
import Categories from './Internal/Categories';
import type {
  FeaturedArticleType,
  ArticleType,
  RecommendedArticleType,
  CategoryType,
} from './Internal/types';

type PropTypes = {|
  title: string,
  subtitle: string,
  intro: string,
  featuredArticle?: FeaturedArticleType,
  articles: Array<ArticleType>,
  recommendedArticles: Array<RecommendedArticleType>,
  categories: Array<CategoryType>,
  page: number,
  totalPages: number,
  urlTemplate: string,
  fieldName: string,
  action: string,
  searchTerm?: string,
|};

export default (props: PropTypes) => {
  return (
    <>
      <Header title={props.title} subtitle={props.subtitle}>
        {props.intro}
      </Header>
      <div className={styles.newsLanding}>
        <div className={styles.main}>
          {props.featuredArticle && <FeaturedArticle {...props.featuredArticle} />}
          {props.articles && props.articles.length > 0 && (
            <>
              <h2 className={`${styles.subtitle} ${styles.articleTitle}`}>Latest articles</h2>
              <Articles articles={props.articles} />
              <div className={styles.pagination}>
                <Pagination
                  selected={props.page}
                  total={props.totalPages}
                  urlTemplate={props.urlTemplate}
                />
              </div>
            </>
          )}
        </div>

        <div className={styles.aside}>
          <Search
            className={styles.search}
            searchTerm={props.searchTerm}
            action={props.action}
            fieldName={props.fieldName}
            placeholder="Search blog"
          />
          {props.recommendedArticles.length > 0 && (
            <div className={styles.recommended}>
              <h2 className={styles.subtitle}>We recommend</h2>
              <RecommendedArticles articles={props.recommendedArticles} />
            </div>
          )}
          {props.categories.length > 0 && (
            <div className={styles.categories}>
              <h2 className={`${styles.subtitle} ${styles.hasNoUnderline}`}>Categories</h2>
              <Categories categories={props.categories} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
